import React, { useEffect, useState } from "react";
import { HashRouter, Switch, Route, Redirect } from "react-router-dom";
import { useQlik } from "../context/Qlik";
import { useSelections } from "../context/Selections";
import { useBookMarkBar } from "../context/BookMarkContainer";
import { useModal } from "../context/Modal";
import { useFilterBar } from "../context/FilterBar";
import { useLeftBar } from "../context/LeftBar";
import { useConfig } from "../context/Config";
import { useFilters } from "../context/Filters";
import { useExportId } from "../context/ExportId";
import Overview from "./Overview/Overview";
import Insights from "./Insights/Insights";
import Detail from "./Detail/Detail";
import LeftSideMenu from "../components/LeftSideMenu/LeftSideMenu";
import AppLoader from "../components/AppLoader/AppLoader";
import FilterMenu from "../components/FilterMenuNative/FilterMenu";
import Header from "../components/Header/Header";
import "../style.scss";

function Layout() {
  console.log("<QlikProvider/>:", useQlik());
  const { qlik, qlikConfig, setActualApp } = useQlik();
  console.log("<SelectionsProvider/>:", useSelections());
  console.log("<BookMarkProvider/>:", useBookMarkBar());
  console.log("<ModalProvider/>:", useModal());
  console.log("<FilterBarProvider/>:", useFilterBar());
  const { filterBarOpened } = useFilterBar();
  console.log("<LeftBarProvider/>:", useLeftBar());
  const { leftBarOpened } = useLeftBar();
  console.log("<ConfigProvider/>:", useConfig());
  const { config } = useConfig();
  console.log("<FiltersProvider/>:", useFilters());
  console.log("<ExportIdProvider/>:", useExportId());
  const [app, setApp] = useState();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (qlik) {
      setIsLoading(false);
      const qvfId = process.env.REACT_APP_QVF_ID;
      const tempApp = qlik.openApp(qvfId, qlikConfig);
      window.app = tempApp;
      setApp(tempApp);
      setActualApp(tempApp);
    }
  }, [qlik, qlikConfig, setActualApp]);

  useEffect(() => {
    if (qlik) setTimeout(qlik.resize, 500);
  }, [qlik]);

  return isLoading ? (
    <AppLoader />
  ) : (
    <div
      style={{ left: leftBarOpened && "224px" }}
      className={filterBarOpened ? "appWrapper is-right-opened" : "appWrapper"}
    >
      <div id="expandedWrapper" />
      <HashRouter>
        <LeftSideMenu app={app} config={config} />
        <Header />
        <FilterMenu
          app={app}
          filters={config?.app?.filters || {}}
          config={config}
        />
        <Switch>
          <Route exact path="/">
            <Redirect to="/overview" />
          </Route>
          <Route
            path="/overview"
            exact
            render={() => <Overview app={app} config={config} />}
          />

          <Route
            path="/details"
            exact
            render={() => <Detail app={app} config={config} />}
          />
        </Switch>
      </HashRouter>
    </div>
  );
}

export default Layout;
